define('gumbo-js-client-lib/forms/gameData/StatusForm',{
	abstractGamestate: null,
	codedGamestate: null,
	detailedState: null,
	statusCode: null,
	reason: null,
	challenges: {
		hasChallenges: null,
		away: {
			used: null,
			remaining: null
		},
		home: {
			used: null,
			remaining: null
		},
		status: null,
		challengingTeam: null
	}
});
